module.exports = {"name":"youboralib","type":"lib","tech":"js","author":"Jordi Aguilar","version":"6.0.9","built":"2017-10-10","repo":"https://bitbucket.org/npaw/lib-plugin-js.git"}


//////////////////
// WEBPACK FOOTER
// ./~/youbora-adapter-videojs5/~/youboralib/manifest.json
// module id = 52
// module chunks = 0